module.exports = __webpack_public_path__ + "static/img/p8.11c9b86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/p8.jpg
// module id = 69
// module chunks = 1